import { create } from 'zustand'
import { BRUSH_SIZES, DEFAULT_BRUSH_SIZE } from '../constants/brushSizes'
import type { BrushSize } from '../constants/brushSizes'
import { DEFAULT_COLOR, PAINT_COLORS } from '../constants/colors'
import type { PaintColor } from '../constants/colors'
import { DEFAULT_IMAGE_SIZE, IMAGE_SIZES } from '../constants/imageSizes'
import type { ImageSize } from '../constants/imageSizes'
import { DEFAULT_SHAPE_KIND, SHAPE_KINDS } from '../constants/shapes'
import type { ShapeKind, ShapeKindDef } from '../constants/shapes'

export type ToolId = 'marker' | 'eraser' | 'bucket' | 'text' | 'image' | 'shape'

export type OpenPanel =
  | 'colors'
  | 'brush'
  | 'images'
  | 'imageSize'
  | 'shape'
  | null

export interface PaintState {
  activeTool: ToolId
  color: PaintColor
  brushSize: BrushSize
  imageSize: ImageSize
  shapeKind: ShapeKindDef
  soundEnabled: boolean
  openPanel: OpenPanel
  setActiveTool: (id: ToolId) => void
  setColor: (id: PaintColor['id']) => void
  setBrushSize: (id: BrushSize['id']) => void
  setImageSize: (id: ImageSize['id']) => void
  setShapeKind: (id: ShapeKind) => void
  toggleSound: () => void
  togglePanel: (id: OpenPanel) => void
  closePanel: () => void
}

export const usePaintStore = create<PaintState>((set) => ({
  activeTool: 'marker',
  color: DEFAULT_COLOR,
  brushSize: DEFAULT_BRUSH_SIZE,
  imageSize: DEFAULT_IMAGE_SIZE,
  shapeKind: DEFAULT_SHAPE_KIND,
  soundEnabled: false,
  openPanel: null,
  setActiveTool: (id) => set({ activeTool: id }),
  setColor: (id) => {
    const color = PAINT_COLORS.find((c) => c.id === id)
    if (color) set({ color })
  },
  setBrushSize: (id) => {
    const brushSize = BRUSH_SIZES.find((b) => b.id === id)
    if (brushSize) set({ brushSize })
  },
  setImageSize: (id) => {
    const imageSize = IMAGE_SIZES.find((s) => s.id === id)
    if (imageSize) set({ imageSize })
  },
  setShapeKind: (id) => {
    const shapeKind = SHAPE_KINDS.find((s) => s.id === id)
    if (shapeKind) set({ shapeKind })
  },
  toggleSound: () => set((s) => ({ soundEnabled: !s.soundEnabled })),
  togglePanel: (id) =>
    set((s) => ({ openPanel: s.openPanel === id ? null : id })),
  closePanel: () => set({ openPanel: null }),
}))
